import { Form } from "react-bootstrap";
import { ScenarioData } from "./mock-data";

interface Props {
  scenario: ScenarioData;
  onChange: (next: ScenarioData) => void;
}

type StringField = Exclude<keyof ScenarioData, "picksRemaining">;

const STRING_FIELDS: { key: StringField; label: string; multiline?: boolean }[] =
  [
    { key: "eventName", label: "Event name" },
    { key: "poolName", label: "Pool name" },
    { key: "winCondition", label: "Win condition", multiline: true },
    { key: "contestantName", label: "Contestant name" },
    { key: "balanceLabel", label: "Balance label" },
    { key: "balanceValue", label: "Balance value" },
    { key: "oddsLabel", label: "Odds" },
    { key: "expReturn", label: "Exp. return" },
  ];

const ScenarioEditor = ({ scenario, onChange }: Props) => {
  const set = <K extends keyof ScenarioData>(key: K, value: ScenarioData[K]) =>
    onChange({ ...scenario, [key]: value });

  return (
    <>
      {STRING_FIELDS.map(({ key, label, multiline }) => (
        <Form.Group key={key} style={{ marginBottom: 12 }}>
          <Form.Label style={{ fontSize: 12, marginBottom: 2 }}>
            {label}
          </Form.Label>
          {multiline ? (
            <Form.Control
              as="textarea"
              rows={3}
              value={(scenario[key] as string) ?? ""}
              onChange={(e) => set(key, e.target.value)}
            />
          ) : (
            <Form.Control
              type="text"
              value={(scenario[key] as string) ?? ""}
              onChange={(e) => set(key, e.target.value)}
            />
          )}
        </Form.Group>
      ))}
      <Form.Group style={{ marginBottom: 0 }}>
        <Form.Label style={{ fontSize: 12, marginBottom: 2 }}>
          Picks remaining (basic)
        </Form.Label>
        <Form.Control
          type="number"
          value={scenario.picksRemaining ?? 0}
          onChange={(e) => set("picksRemaining", Number(e.target.value) || 0)}
        />
      </Form.Group>
    </>
  );
};

export default ScenarioEditor;
